import api from './client';
import type { PartnerInfos } from 'types';

export const partnersApi = {
  list: async (params?: { org_id?: string; company_type?: string; limit?: number; offset?: number; sort_by?: string; sort_dir?: string }): Promise<PartnerInfos[]> => {
    const { data } = await api.get('/partners', { params });
    return data;
  },

  get: async (partnerId: string): Promise<PartnerInfos> => {
    const { data } = await api.get(`/partners/${partnerId}`);
    return data;
  },

  create: async (partner: Omit<PartnerInfos, 'id'> & { org_id: string }): Promise<PartnerInfos> => {
    const { data } = await api.post('/partners', partner);
    return data;
  },

  update: async (partnerId: string, updates: Partial<PartnerInfos>): Promise<PartnerInfos> => {
    const { data } = await api.patch(`/partners/${partnerId}`, updates);
    return data;
  },

  checkDuplicate: async (params: { org_id: string; company_name?: string; email?: string; company_email?: string }): Promise<{
    status: "available" | "similar" | "exact";
    matches: Array<{ id: string; company_name: string; display_name: string; email: string; phone_number: string; company_types: string[] }>;
  }> => {
    const { data } = await api.get('/partners/check-duplicate', { params });
    return data;
  },

  delete: async (partnerId: string): Promise<void> => {
    await api.delete(`/partners/${partnerId}`);
  },

  uploadDecennale: async (partnerId: string, startDate: string, endDate: string, file: globalThis.File, projectId?: string): Promise<PartnerInfos> => {
    const formData = new FormData();
    formData.append('file', file);
    const params: Record<string, string> = { start_date: startDate, end_date: endDate };
    if (projectId) params.project_id = projectId;
    const { data } = await api.post(`/partners/${partnerId}/decennale`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params,
    });
    return data;
  },

  updateDecennaleDates: async (partnerId: string, oldStartDate: string, newStartDate: string, newEndDate: string): Promise<PartnerInfos> => {
    const { data } = await api.patch(`/partners/${partnerId}/decennale`, null, {
      params: { old_start_date: oldStartDate, new_start_date: newStartDate, new_end_date: newEndDate },
    });
    return data;
  },

  deleteDecennale: async (partnerId: string, startDate: string): Promise<PartnerInfos> => {
    const { data } = await api.delete(`/partners/${partnerId}/decennale`, {
      params: { start_date: startDate },
    });
    return data;
  },
};
